<template>
  <BaseCardV2
    v-if="!loading && (hasDonneesEvolutionNumtiers || hasDonneesEvolutionGroupe)"
    :chip="{libelle: 'Prix ferme'}"
    :has-btn-action="false"
    has-help
    titre="évolution des prix de contrat"
    @on-help="isOpenModalHelp = true"
  >
    <BaseLoader v-if="loading" />
    <BaseComparaisonLegende
      v-if="!loading && datasetPrixContratNumtiers!= null"
      :donnee-groupe="hasDonneesGroupe && hasRegionSelected ? {libelle:'Mon groupe'} : null"
      :donnee-perso="hasDonneesEvolutionNumtiers ? {libelle:'Mon exploitaton'} : null"
      :couleur-primaire="datasetPrixContratNumtiers.borderColor"
      :couleur-secondaire="datasetPrixContratGroupe.borderColor"
      class="ml-3 my-5"
    />
    <BaseComparaisonLineChart
      v-if="!loading"
      :id="chartData.id"
      :chart-data="chartData"
      class="mt-5 mb-2 pr-3"
      ordonnee="€/t"
      tooltip-label-groupe="Mon groupe "
      tooltip-label-perso="Mon exploitaton : "
      unite="€/t"
    />
    <HelpModal
      v-if="isOpenModalHelp"
      titre="évolution des prix de contrat"
      :is-open-modal-help="isOpenModalHelp"
      @close="isOpenModalHelp = false"
    >
      <div slot="baseCardHelpContent">
        <div class="texte text-justify texte-gris-fonce pa-8">
          <p>Les prix affichés sont des prix de contrat moyen par adhérent.</p>
        </div>
      </div>
    </HelpModal>
  </BaseCardV2>
</template>

<script>
import BaseCardV2 from '@/components/card/base-card-v2.vue'
import BaseComparaisonLineChart from '@/components/chart/base-comparaison-line-chart.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import BaseComparaisonLegende from '@/components/chart/base-comparaison-legende.vue'
import HelpModal from '@/components/modal/help-modal.vue'
import {mapGetters} from 'vuex'
import colorsService from '@/service/colors.service'

export default {
  name: 'EvolutionPrixContratPrixFerme',
  components: { HelpModal, BaseCardV2, BaseComparaisonLineChart, BaseLoader, BaseComparaisonLegende },
  props: {
    loadingAdherent: {
      type: Boolean,
      default: null
    },
    loadingGroupe: {
      type: Boolean,
      default: null
    },
    erreurAdherent: {
      type: Boolean,
      default: null
    },
    erreurGroupe: {
      type: Boolean,
      default: null
    },
    hasRegionSelected: {
      type: Boolean,
      default: null
    }
  },
  data () {
    return {
      isOpenModalHelp: false,
      erreur: false,
    }
  },
  computed: {
    ...mapGetters({
      evolutionPrixContratNumtiers: 'contrat/evolutionPrixContratNumtiers',
      evolutionPrixContratGroupe: 'contrat/evolutionPrixContratGroupe',
      filtresAdherent: 'filtresComparaison/filtresAdherent'
    }),
    loading () {
      return this.loadingAdherent || this.loadingGroupe
    },
    datasetPrixContratNumtiers () {
      return {
        type: 'line',
        label: 'Mon exploitation',
        fill: false,
        tension: 0.3,
        borderColor: colorsService.barChart.grapheCompositionQualite.perso,
        backgroundColor: colorsService.barChart.grapheCompositionQualite.perso,
        data: this.evolutionPrixContratNumtiers ? this.evolutionPrixContratNumtiers.map(e => e.prixContrat) : []
      }
    },
    datasetPrixContratGroupe () {
      if (this.evolutionPrixContratGroupe.prixContratAnnuelsGroupe != null) {
        const serie = this.evolutionPrixContratGroupe.prixContratAnnuelsGroupe
        return {
          type: 'line',
          label: 'Mon groupe',
          fill: false,
          tension: 0.3,
          borderColor: colorsService.barChart.grapheCompositionQualite.groupe,
          backgroundColor: colorsService.barChart.grapheCompositionQualite.groupe,
          data: serie.map(e => e.prixContratAnnuel.prixContrat),
          nbGroupe: serie != null && this.hasRegionSelected ? serie.map(e => e.nbAdherentCompares) : []
        }
      }
      return null
    },
    datasets () {
      let result = []
      if (this.hasDonneesEvolutionNumtiers) {
        result.push(this.datasetPrixContratNumtiers)
      }
      if (this.hasRegionSelected) {
        result.push(this.datasetPrixContratGroupe)
      }
      return result
    },
    chartData () {
      return {
        title: '',
        labels: this.evolutionPrixContratNumtiers ? this.evolutionPrixContratNumtiers.map(e => e.annee) : [],
        datasets: this.datasets,
        unite: '€',
        id: 'chartEvolutionPrixContrat'
      }
    },
    hasDonneesEvolutionNumtiers () {
      return this.evolutionPrixContratNumtiers.length
        ? this.evolutionPrixContratNumtiers.map(e => e.prixContrat).filter(f => f != null).length > 0
        : false
    },
    hasDonneesEvolutionGroupe () {
      return this.evolutionPrixContratGroupe.prixContratAnnuelsGroupe!= null && this.evolutionPrixContratGroupe.length
        ? this.evolutionPrixContratGroupe.prixContratAnnuelsGroupe.map(e => e.prixContratAnnuel.prixContrat).filter(f => f != null).length > 0
        : false
    },
    hasDonneesGroupe () {
      return this.evolutionPrixContratGroupe.prixContratAnnuelsGroupe!= null ? this.evolutionPrixContratGroupe.prixContratAnnuelsGroupe.map(r => r.nbAdherentCompares).filter(f => f > 0).length > 0 : false
    }
  }
}
</script>
